document.addEventListener('DOMContentLoaded', function() {
  // Get references to all filter groups, product items, and the clear filters button
  const filterGroups = document.querySelectorAll('.solutello-advanced-grid .filter-group');
  const productItems = document.querySelectorAll('.solutello-advanced-grid .product-item');
  const clearFiltersButton = document.querySelector('.solutello-advanced-grid .clear-filters');

  // Initialize an object to store the currently active filters
  let activeFilters = {};

  // Iterate over each filter group
  filterGroups.forEach(group => {
    const filterList = group.querySelector('.filter-list');
    const filterType = filterList.dataset.filterType;
    const filterLinks = filterList.querySelectorAll('a, input[type="checkbox"]');

    // Initialize the active filters for this filter type as an empty array
    activeFilters[filterType] = [];

    // Add event listeners to each filter link or checkbox
    filterLinks.forEach(link => {
      link.addEventListener('click', function(event) {
        // Prevent default behavior for anchor tags
        if (this.tagName === 'A') {
            event.preventDefault();
        }

        // Get filter details from the clicked element
        const filterValue = this.dataset.filterValue;
        const filterText = this.dataset.filterText;
        const isCheckbox = this.tagName === 'INPUT';
        const linkParent = this.closest('.filter-item');

        // Handle checkbox and non-checkbox filter interactions
        if (isCheckbox) {
            // For checkboxes, add or remove the filter value based on checked status
            if (this.checked) {
                if (!activeFilters[filterType].includes(filterValue)) {
                    activeFilters[filterType].push(filterValue);
                }
            } else {
                activeFilters[filterType] = activeFilters[filterType].filter(val => val !== filterValue);
            }
        } else {
            // For non-checkboxes (links), toggle the filter on/off
            if (activeFilters[filterType].includes(filterValue)) {
                activeFilters[filterType] = activeFilters[filterType].filter(val => val !== filterValue);
            } else {
                activeFilters[filterType] = [filterValue];
            }
        }

        // Toggle active class for visual feedback and improved UX
        if (isCheckbox) {
            linkParent.classList.toggle('active', this.checked);
        } else {
            // Remove active class from all links in the same group
            filterLinks.forEach(l => {
                if (l !== this) {
                    l.closest('.filter-item').classList.remove('active');
                }
            });

            // Toggle active class for the clicked link
            linkParent.classList.toggle('active', activeFilters[filterType].includes(filterValue));
        }

        // Apply filtering to the products
        filterProducts();
      });
    });
  });

  // Function to filter products based on active filters
  function filterProducts() {
    productItems.forEach(item => {
      let isVisible = true;

      // Iterate over each filter type and check if the product matches
      for (let filterType in activeFilters) {
        if (activeFilters[filterType].length > 0) {
          let matchesFilter = false;
          if (filterType === 'collection') {
            const collections = item.dataset.collections.split(',');
            matchesFilter = activeFilters[filterType].some(val => collections.includes(val));
          } else if (filterType === 'tag') {
            const tags = item.dataset.tags.split(',');
            matchesFilter = activeFilters[filterType].some(val => tags.includes(val));
          } else if (filterType === 'variant') {
            const variants = JSON.parse(item.dataset.variants);
            matchesFilter = activeFilters[filterType].some(val => variants.some(variant => variant.options.includes(val)));
          } else if (filterType === 'metafield') {
            const metafields = JSON.parse(item.dataset.metafields);
            matchesFilter = activeFilters[filterType].some(val => {
                let metafieldMatch = false;
                for (let filter in activeFilters) {
                    for (let metafield_key in activeFilters[filter]){
                        const [namespace, key] = metafield_key.split('.');
                        metafieldMatch = metafields[namespace] && metafields[namespace][key] === val;
                    }
                }
                return metafieldMatch;
            });
          }

          // If the product doesn't match the filter, set isVisible to false and break
          if (!matchesFilter) {
            isVisible = false;
            break;
          }
        }
      }

      // Update the product's display style based on isVisible
      item.style.display = isVisible ? 'block' : 'none';
    });

    // Update the visibility of filter options based on current product display
    updateFilterOptions();
  }

  // Function to update the visibility of filter options
    function updateFilterOptions() {
        filterGroups.forEach(group => {
            const filterType = group.querySelector('.filter-list').dataset.filterType;
            const filterOptions = group.querySelectorAll('.filter-item');

            filterOptions.forEach(option => {
                const filterValue = option.querySelector('a, input[type="checkbox"]').dataset.filterValue;
                let optionMatchesProduct = false;

                productItems.forEach(product => {
                    if (product.style.display !== 'none') {
                        if (filterType === 'collection') {
                            const collections = product.dataset.collections.split(',');
                            if (collections.includes(filterValue)) optionMatchesProduct = true;
                        } else if (filterType === 'tag') {
                            const tags = product.dataset.tags.split(',');
                            if (tags.includes(filterValue)) optionMatchesProduct = true;
                        } else if (filterType === 'variant') {
                            const variants = JSON.parse(product.dataset.variants);
                            if (variants.some(variant => variant.options.includes(filterValue))) optionMatchesProduct = true;
                        } else if (filterType === 'metafield') {
                            const metafields = JSON.parse(product.dataset.metafields);
                            if (activeFilters[filterType].some(val => {
                                let metafieldMatch = false;
                                for (let filter in activeFilters) {
                                    for (let metafield_key in activeFilters[filter]){
                                        const [namespace, key] = metafield_key.split('.');
                                        metafieldMatch = metafields[namespace] && metafields[namespace][key] === val;
                                    }
                                }
                                return metafieldMatch;
                            })) optionMatchesProduct = true;
                        }
                    }
                });
                option.style.display = optionMatchesProduct ? 'block' : 'none';
            });
        });
    }

  // Add event listener to the clear filters button
  clearFiltersButton.addEventListener('click', function() {
    // Reset active filters object
    activeFilters = {};

    // Iterate over each filter group and reset the filters
    filterGroups.forEach(group => {
      const filterList = group.querySelector('.filter-list');
      const filterType = filterList.dataset.filterType;
      activeFilters[filterType] = [];

      // Get all filter links and checkboxes within the group
      const filterLinks = filterList.querySelectorAll('a, input[type="checkbox"]');

      // Reset each filter link and checkbox
      filterLinks.forEach(link => {
        const linkParent = link.closest('.filter-item');
        linkParent.classList.remove('active');
        if (link.tagName === 'INPUT') {
            link.checked = false;
        }
      });
    });

    // Re-filter the products based on the reset filters
    filterProducts();
  });
});